import { DEFAULT_PAGE_SIZE } from '../../utils/constant'

/**
 * Builds a redux-thunk that loads one page of list data, sets `result.page` to a
 * 1-based index for the UI, and dispatches `{ type, payload: result }`.
 *
 * `fetchApi(page, pageSize)` — page is 0-based page index.
 * Thunk call: `(page = 0, second, third)` where `second` may be pageSize (number) or callback.
 */
export const createPagedFetchThunk = ({ type, fetchApi }) => {
	return (page = 0, second, third) => async dispatch => {
		let pageSize = DEFAULT_PAGE_SIZE
		let callback
		if (typeof second === 'function') {
			callback = second
		} else if (typeof second === 'number') {
			pageSize = second
			callback = third
		}
		try {
			const result = await fetchApi(page, pageSize)
			result.page = page + 1
			dispatch({
				type,
				payload: result,
			})
			callback && callback(true, result)
		} catch (err) {
			callback && callback(false, err.message)
		}
	}
}
